import { apiGet } from '../../api'

export const get_greenlight_survey = query => {
  return apiGet({
    endpoint: `greenlight/get_survey?id=${query}`
  })
}
